// ----------------------------------------------------------------------------
// Template: Product
// ----------------------------------------------------------------------------
//
// ----------------------------------------------------------------------------


// -------------------------------------
// Dependencies
// -------------------------------------

// Scripts
import {load} from '@shopify/theme-sections';
import 'snippets/breadcrumbs/breadcrumbs';
import 'snippets/reviews/reviews';
import 'snippets/cart-confirmation/cart-confirmation';
import 'snippets/_containers/swatches/swatches';
import 'snippets/_containers/form/form-increment';
import 'snippets/variant-picker/variant-picker';

import 'sections/header/header';
import 'sections/footer/footer';
import 'sections/country-modal/country-modal';
import 'sections/product/product';
import 'sections/product-recommendations/product-recommendations';
import 'sections/pdp-tabs/pdp-tabs';
import 'sections/related-forks/related-forks';
import 'sections/fitment-table/fitment-table';
import 'sections/spring-rate-calculator/spring-rate-calculator';


// Styles
import './_product.scss';


// -------------------------------------
// Hooks
// -------------------------------------
document.addEventListener('DOMContentLoaded', () => {
    load('*');
});
